import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap

const options = {
  responsive: {
    0: { items: 1 },
    768: { items: 2 },
    1024: { items: 2 },
  },
};

const Testimonial = ({ ImpressionList }) => {
  return (
    <div className="w-100   pt-2 pt-lg-5">
      <h2 className="text-center f36 container fw-bold fs-3">
        <span className="text-primary">Voice of</span> Customer
      </h2>

      <div className=" testimonialbghivalueplus  mt-2 mt-lg-4">
        <div className="container pb-5 pt-2 pt-lg-5">
          <OwlCarousel
            className="owl-theme custom-carousel blue-nav container-fluid"
            loop={true}
            animateIn="fadeIn"
            animateOut="fadeOut"
            autoplaySpeed={2000}
            autoplay={true}
            margin={25}
            items={2}
            nav={true}
            dots={false}
            {...options}
          >
            {ImpressionList.map((item, index) => (
              <div key={index} className="  rounded py-2">
                
                    <img
                      src={item.image}
                      alt="testimonial"
                      
                      className=" rounded hivalueplustestimonialimg "
                    />
                 
                  <div className="  text-secondary text-start mt-2">
                    <p className="">{item.message}</p>
                    <p className="mt-4 fw-semibold text-dark">
                      — {item.name} | {item.city}
                    </p>
                  </div>

                 
              </div>
            ))}
          </OwlCarousel>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
